module.exports = __webpack_public_path__ + "static/media/96.7512f165.jpg";